module.exports = __webpack_public_path__ + "img/gift.e6b71f15.svg";